import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

const request = async (path, options = {}) => {
  if (!SERVER_URL) {
    throw new Error('API server URL is not configured');
  }

  const response = await fetch(`${SERVER_URL}${path}`, {
    ...options,
    headers: authService.getAuthHeaders(),
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || data.message || `Request failed with status ${response.status}`);
  }
  return data;
};

const requestBlob = async (path) => {
  const response = await fetch(`${SERVER_URL}${path}`, {
    headers: authService.getAuthHeaders(),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Request failed with status ${response.status}`);
  }
  return response.blob();
};

export const montageProfilesService = {
  async getProfiles({ includeInactive = true } = {}) {
    const result = await request(
      `/montage-profiles?include_inactive=${includeInactive ? 'true' : 'false'}`
    );
    return Array.isArray(result.data) ? result.data : [];
  },

  async createProfile(profile) {
    return request('/montage-profiles', {
      method: 'POST',
      body: JSON.stringify(profile),
    });
  },

  async updateProfile(key, updates) {
    return request(`/montage-profiles/${encodeURIComponent(key)}`, {
      method: 'PUT',
      body: JSON.stringify(updates),
    });
  },

  async deactivateProfile(key) {
    return request(`/montage-profiles/${encodeURIComponent(key)}`, {
      method: 'DELETE',
    });
  },

  async getPreviewSource(generationId) {
    const result = await request(
      `/generations/${encodeURIComponent(generationId)}/montage-profile-preview-source`
    );
    return result.data;
  },

  async createExactPreview(generationId, payload) {
    const result = await request(
      `/generations/${encodeURIComponent(generationId)}/montage-profile-previews`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      }
    );
    return result.data;
  },

  async getExactPreview(generationId, jobId) {
    const result = await request(
      `/generations/${encodeURIComponent(generationId)}/montage-profile-previews/${
        encodeURIComponent(jobId)
      }`
    );
    return result.data;
  },

  async getExactPreviewArtifact(generationId, jobId, artifact) {
    return requestBlob(
      `/generations/${encodeURIComponent(generationId)}/montage-profile-previews/${
        encodeURIComponent(jobId)
      }/artifacts/${encodeURIComponent(artifact)}`
    );
  },
};
